<template>
  <div class="animated fadeIn list-of-ap">
    <b-card>
      <div slot="header">List of AR Invoice Revison/Void 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="add">Add</b-button>
          <b-button variant="primary mr-1" @click="edit">Edit</b-button>
          <b-button variant="primary mr-1" @click="deleteConfirm">Delete</b-button>
          <b-button variant="primary mr-1" @click="print()"><i class="fa fa-print"></i> Print Inv.</b-button>
          <b-button variant="primary mr-1" @click="posting()"><i class="fa fa-paper-plane"></i> Posting</b-button>
          <b-button variant="primary mr-1" @click="printjv()"><i class="fa fa-print"></i> Print Jv</b-button>
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i>Export</b-button>
          <b-button variant="primary mr-1" @click="togleFilter()"><i class="fa fa-filter"></i> Filter</b-button>
          <b-button variant="primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</b-button>
        </div>
      </div>
      <b-row v-if="showFilter">
        <b-col lg="6">
            <b-row>
              <b-col lg="8">
                  <b-input-group >
                    <b-input-group-prepend><label>Revision Date</label></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl1" type="date" ></b-form-input>
                    <b-input-group-prepend><span class="input-group-text">until</span></b-input-group-prepend>
                    <b-form-input v-model="tblData.tgl2" type="date" ></b-form-input>
                  </b-input-group>
                </b-col>
            </b-row>            
              <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Invoice Number</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.nomor" placeholder="AR Invoice Number"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col lg="4">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Source &nbsp;</span></b-input-group-prepend>
                      <b-form-select v-model="tblData.invmanual" :plain="true" :options="invSources"></b-form-select>
                    </b-input-group>
                </b-col>
              </b-row>                      

            <b-input-group >
                <b-input-group-prepend><label>Dimension Name</label></b-input-group-prepend>
                <b-form-select v-model="tblData.DimCol" :plain="true" :options="dimension"></b-form-select>
                <b-input-group-prepend><span class="input-group-text">value</span></b-input-group-prepend>
                <b-form-input v-model="tblData.DimVal" placeholder="Dimension Value"></b-form-input>
              </b-input-group>
        </b-col>
        <b-col lg="6">
              <b-row>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Customer</label></b-input-group-prepend>
                      <b-form-input v-model="tblData.customer" placeholder="Customer"></b-form-input>
                    </b-input-group>
                  </b-col>
                <b-col  lg="6">
                    <b-input-group >
                      <b-input-group-prepend><span class="pt-2">Order Number &nbsp;</span></b-input-group-prepend>
                      <b-form-input v-model="tblData.po" placeholder="Purch. Order#"></b-form-input>
                    </b-input-group>
                </b-col>
              </b-row>            
            <b-input-group >
                <b-input-group-prepend><label>Description</label></b-input-group-prepend>
                <b-form-input v-model="tblData.uraian" ></b-form-input>
            </b-input-group>
              <b-row no-gutters>
                <b-col lg="6">
                    <b-input-group >
                      <b-input-group-prepend><label>Posting Group</label></b-input-group-prepend>
                      <b-form-select v-model="tblData.postgroup" :plain="true" :options="postGroups"></b-form-select>
                    </b-input-group>
                  </b-col>
                <b-col  lg="2">
                      <b-form-select v-model="tblData.posting" :plain="true" :options="dataList.postingStatus"></b-form-select>
                </b-col>
                <b-col lg="4" >
                    <b-button class="btn btn-success ml-3" @click="search()" > <i class="fa fa-refresh"></i> Apply Filter</b-button>
                    <b-button class="btn btn-secondary" @click="clearFilter()" > <i class="fa fa-eraser"></i>Clear Filter</b-button>
                </b-col>
              </b-row>                      
        </b-col>
      </b-row>
      <b-table
        class="mb-0"
        ref="table"
        outlined
        responsive striped hover
        style="font-size:smaller;" 
        :items="data"
        :fields="tblFields"
        :current-page="tblData.page"
        :per-page="tblData.limit"
        :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc"
        :key="tblData.limit"  @row-clicked="rowClicked" 
      >
        <template v-slot:cell(invoiceno)="data">
          <div v-if="data.item.posting==0" style="background-color:yellow;">           
            {{(data.item.invoiceno)}}
          </div>
          <div v-else> 
            {{(data.item.invoiceno)}}
          </div>
        </template>
        <template v-slot:cell(tanggal)="data">
          {{ data.item.tanggal | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(invdate)="data">
          {{ data.item.invdate | moment("DD MMM YYYY") }}
        </template>
        <template v-slot:cell(custinfo)="data">
          {{data.item.custinfo}} 
          <span v-if="(data.item.custinfo!=data.item.custinfoB4)" style="background-color:pink;">           
            (CHANGED) 
          </span>
        </template>

        <template v-slot:cell(ttlamtdueB4)="data">
          {{data.item.ttlamtdueB4 | numFormat}}
        </template>
        <template v-slot:cell(ttlamtdue)="data">
          <div v-if="(data.item.ttlamtdue!=data.item.ttlamtdueB4)" style="background-color:pink;">           
            {{(data.item.ttlamtdue)|numFormat}}
          </div>
          <div v-else> 
            {{(data.item.ttlamtdue)|numFormat}}
          </div>
        </template>

      </b-table>
      <b-row >
        <b-col cols="5">
          <div>
            Showing {{(tblData.page - 1) * tblData.limit + 1}}
            to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="2" >
            <b-input-group >
                <b-input-group-prepend><span  class="pt-1 mr-2">Limit per page</span></b-input-group-prepend>
                <b-form-select :options="[10, 20, 30, 50, 70, 90, 120]" :plain="true" v-model="tblData.limit"  size="sm" style="width:80px;"/>
            </b-input-group>
        </b-col>        
        <b-col cols="5">            
          <b-pagination v-if="pagination"
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.limit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>
      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
      <b-modal v-model="showPostingConfirm" title="Posting Record?" :centered="true" @ok="postingData">
        <p class="mb-1">The selected a row of data will be Posted to Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">You can unpost as long as <strong>Accounting Periode</strong> stil open</p>
      </b-modal>
      <b-modal v-model="showUnpostConfirm" title="Un Posting Record?" :centered="true" @ok="unpostData">
        <p class="mb-1">The selected a row of data will be UnPosted from Accounting?</p>
        <p class="font-weight-bold m-0 text-danger">Data Journal will be removed from <strong>Accounting</strong></p>
      </b-modal>
    </b-card>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" hide-footer>
        <iframe :src="reportUrl" frameborder="0"></iframe>
        <b-row class="justify-content-center mt-1">
            <b-button variant="primary" v-if="(isprintjv==true)" @click.stop="editjv">Edit Journal</b-button>
            <b-button variant="secondary" class="ml-2" @click="showReport=false" > Close</b-button>
        </b-row>
    </b-modal>
  </div>
</template>

<style lang="scss">
    .ColsDefine {
      .input-group {
          .input-group-prepend {
              label {
                  width: 135px !important;
              }
          }
      }
    }

</style>


<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import moment from "moment";
import arinvrevision from "../../apis/arinvrevision";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
toastr.init();

export default {   
  components: {Loading},
  data() {
    return {
      showFilter: false,
      showDelConfirm: false,
      showPostingConfirm: false,
      showUnpostConfirm: false,
      isLoading:false,
      isprintjv:false,
      showReport:false,
      reportUrl: null,
      tblData: {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: 'tanggal',
        sortDesc: true,
        DimCol:'Dim1'
      },
      pagination:false,
      items:[],
      model:{},
      artypes:[],
      arWithSale:[],
      invSources:[{ value: '', text: '--- ALL ---'},{ value: 'arinvtt', text: 'AR Invoice'},{ value: 'arinvtt2', text: 'Realisasi Proforma'}],
      postGroups:[{ value: '', text: '--- ALL ---'}],
      dataList: {
        YesNoAll: dropdown.ostandStatus,
        postingStatus: dropdown.postingStatus,
        ostandStatus:[{value:'',text:''}],
      }      
    };
  },
  computed: {
    dimension(){
      return this.$store.state.dimension;
    },
    tblFields(){
      const fields=[
          {
            key: "tanggal",
            thStyle: "width:90px",
            label: "Revision date",
            sortable: true
          },
          {
            key: "invoiceno",
            thStyle: "width:150px",
            label: "Invoice Number",
            sortable: true
          },
          {
            key: "invdate",
            thStyle: "width:90px",
            label: "Inv. Date",
            sortable: true
          },
          {
            key: "custinfo",
            label: "Customer",
            sortable: true
          },
          {
            key: "uraian",
            label: "Description",
            sortable: true
          },
          {
            key: "matauang",
            thStyle: "width:40px",
            label: "$,¥",
            sortable: true
          },
          {
            key: "ttlamtdueB4",
            label: "Amount Before",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "ttlamtdue",
            label: "Amount After",
            thStyle: "width:150px",
            thClass: "text-right",
            tdClass: "text-right",
            sortable: true
          },
          {
            key: "ordernumber",
            thStyle: "width:150px",
            label: "PO/SO #",
            sortable: true
          },
          {
            key: "invoicereff",
            thStyle: "width:150px",
            label: "Inv. Refer#",
            sortable: true
          },
        ];
        const dims = this.$store.state.dimension;
        for (let i = 0; i < dims.length; i += 1) {
          fields.push(          {
            key: `${dims[i].value}Txt`,
            thStyle: "width:100px",
            label: dims[i].text,
            sortable: true
          },)
        }
      return fields;
    },
    dimCol() {
        return this.tblData.DimCol;
    },
    invalidModel() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  watch:{
    dimCol: function(newval) {
        this.tblData.DimVal="";
        this.tblData.DimValInfo="";
        this.tblData.DimColInfo=this.dimension.find(d => d.value === newval).text;
    },
  },
  created: function(){
        setTimeout(async () => {
            const [a,b] = await Promise.all([arinvrevision.postgroup()]) ;
            this.artypes = a;
            // this.dataList.ostandStatus = b;
            // this.dataList.ostandStatus = this.dataList.ostandStatus.concat(b);

            // this.artypes = await arinvrevision.postgroup();
            this.postGroups = this.artypes.reduce((newArr,item) =>{
                if (item.saleCode)
                {
                  this.arWithSale.push(item);
                }
                  newArr.push(item);
                  return newArr;
              },[{ value: '', text: '--- ALL ---'}]);
          
        }, 1000);
        // const tgl2 = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD').add(1,'M').subtract(1, 'day');
        // this.tblData.tgl1= this.tblData.tgl1 || this.$store.state.user.tglaktif;
        // this.tblData.tgl2= this.tblData.tgl2 || tgl2.format('YYYY-MM-DD');
  },  
  methods: {
    data: async function(ctx) {
        const tblOrder={sortBy:this.tblData.sortBy,sortDesc:this.tblData.sortDesc};
        this.pagination=false;
        const filter = this.$store.state.filter;
        let filtered=false;
        for (var key in filter.arinvrlist) {
            this.tblData[key] = filter.arinvrlist[key];
            filtered=true;
        }
        if (filtered === true) {
          if (!(filter.arinvrlist.tgl1)) {
            this.tblData.tgl1='';
            this.tblData.tgl2='';
          }
          this.showFilter=filtered;
          delete filter.arinvrlist;
          this.$store.commit("filter", filter);
          let autoRefresh=true;
            if (this.tblData.page == 1) {
              if ((tblOrder.sortBy ==this.tblData.sortBy) && (tblOrder.sortDesc==this.tblData.sortDesc)) {
                   autoRefresh=false; 
               } else autoRefresh=true; 
            }
            if (autoRefresh==false) {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await arinvrevision.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
            }
        } else {
                this.isLoading=true;
                this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
                try {
                  const list = await arinvrevision.list(this.tblData);      
                  this.pagination=true;
                  this.items = list;
                  this.isLoading=false;  
                  return list;        
                } catch (error) {
                  this.isLoading=false;  
                  if (error.message) {
                      toastr.error(error.message,'ERROR MESSAGE',10000);
                  } else {
                      toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
                  }        
                }
        }

    },
    refresh(ctx) {
      this.$refs.table.refresh();
    },
    search(ctx) {
      this.tblData.page=1;
      this.refresh();
    },
    clearFilter(ctx) {
        this.tblData.customer= '';
        this.tblData.po=  '';
        this.tblData.uraian=  '';
        this.tblData.nomor=  '';
        this.tblData.posting=  '';
        this.tblData.postgroup=  '';
        this.tblData.tgl1=  '';
        this.tblData.tgl2=  '';
        this.tblData.DimVal=  '';
        this.tblData.invmanual=  '';
        this.tblData.ostStatuskey=  '';
        this.$forceUpdate();
    },
    saveFilter() {
      const keys = ['uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'outstand', 'nomor', 'customer', 'po', 'postgroup', 'posting', 'invmanual', 'ostStatuskey'];
      let filtered = false;
      const arinvrlist={};
      for (const key in this.tblData) {
          if (keys.indexOf(key) >= 0 && this.tblData[key]) {
              filtered=true;
              arinvrlist[key]=this.tblData[key];
          }
      }
      if (filtered === true) {
          arinvrlist.page=this.tblData.page;
          arinvrlist.limit=this.tblData.limit;
          arinvrlist.sortBy=this.tblData.sortBy;
          arinvrlist.sortDesc=this.tblData.sortDesc;
          const filter = this.$store.state.filter;
          filter.arinvrlist=arinvrlist;
          this.$store.commit("filter", filter);
      }
    },       
    togleFilter() {
      this.showFilter=!this.showFilter;
    },
    add(){
      this.saveFilter();
      router.push({name :"receivable.arinvrevisionfrm"});
    },
    edit: function() {
        if (this.model) {
          this.saveFilter();
          router.push({name :'receivable.arinvrevisionfrm', params: { arinvreKey: this.model.arinvreKey}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },
    deleteConfirm() {
        if (this.model) {
          this.showDelConfirm = true;
        } else {
            toastr.warn('Please select a row that want to be Delete!');
        }
    },
    deleteData: async function() {
      try {
        this.isLoading=true;
        await arinvrevision.remove(this.model);
      this.refresh();
        // const index= this.items.findIndex(r => (r.arinvreKey==this.model.arinvreKey));
        // this.items.splice(index, 1);
        this.isLoading=false;
      } catch (error) {
                if (error.sql) {
                    toastr.error(error.sql,'ERROR MESSAGE',10000);
                } else if (error.sqlMessage) {
                    toastr.error(error.sqlMessage,'ERROR MESSAGE',10000);
                } else if (error.message) {
                    toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }        
      }
    },
    rowClicked(record, index) {
      // if (this.model.arinvreKey == record.arinvreKey) {
      //     this.edit();
      // } else {
        if ((this.model) && (this.model._rowVariant)) {
            delete this.model._rowVariant;
        }
        this.model = record;
        record._rowVariant= 'info';
        this.$forceUpdate();
      // }
    },
    posting: async function () {
        if (this.model) {
            if ((this.model.posting || 0) == 0) {
                this.showPostingConfirm = true;
            }
            if (this.model.posting == 1) {
                this.showUnpostConfirm = true;
            }
        } else {
            toastr.warn('Please select a row that want to be Posted!');
        }
    }, 
    postingData: async function(){
        this.isLoading=true;
        try {
            await arinvrevision.posting(this.model);
            this.model.posting=1;
            this.printjv();
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    unpostData: async function(){
        this.isLoading=true;
        try {
            await arinvrevision.postingUndo(this.model);
            this.model.posting=0;
            this.isLoading=false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'ERROR MESSAGE',10000);
            } else {
                toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
            }
        }
    },  
    editjv: function() {
        if (this.model) {
            this.saveFilter();
            const tanggal = moment(this.model.invdate).format('YYYY-MM-DD');
          router.push({name :'receivable.editjvfrm', params: { nomor: this.model.invoiceno, tanggal, kodejurnal:'ARINV'}});
        } else {
            toastr.warn('Please select a row that want to be Edit!');
        }
    },    
    printjv: async function()
    {
      if (this.model) {
        if ((this.model.posting || 0) == 1) {
            try {
                this.isprintjv=true;
                this.showReport=true;
                this.reportUrl= await arinvrevision.printjv(this.model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }
            }
        } else {
          toastr.warn('Please do Posting first!');
        }
      } else {
          toastr.warn('Please select a row that want to be Printed!');
      }
    },
    print: async function()
    {
      if (this.model) {
        if ((this.model.posting || 0) == 1) {
          try {
                this.showReport=true;
              this.isprintjv=false;
              this.reportUrl= await arinvrevision.print(this.model);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Print available after Posting process successfull !');
        }
        } else {
            toastr.warn('Please select a row that want to be Printed!');
        }
    },
    exportxls: async function() {
        this.isLoading=true;
        try {
            const response = await arinvrevision.exportxls(this.tblData);
            this.isLoading=false;    
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message);
            } else {
                toastr.error(JSON.stringify(error));
            }
        }
    },
    close(){
      router.push("/receivable/home");
    },    
  }
};
</script>
